// The app's NEUTRAL "no photo" tile (public/media-placeholders/no-image.svg)
// — Fable ruling R10 (2026-10-07). ONE path: the cart line (CartPage's
// CART_NO_PHOTO_SRC) and the care-guide index card (batch 34 C6) both read
// it, so a missing photo looks intentional, never like a blank grey box or
// the old 1x1 translucent-blue placeholder pixel stretched into a purple
// square. Every image fallback in src/ reads this constant (batch 34 review;
// a source sweep in constants/__tests__/noPhotoSweep.test.js holds it).
export const NO_PHOTO_SRC = '/media-placeholders/no-image.svg';
